import { compose } from 'redux';
import type { PopupState } from './reducer';

import type { AppState } from '../AppState';

export const selectPopupDomain = (state: AppState): PopupState => state.popup;

export const selectOpenPopup = compose((state) => state.openPopup, selectPopupDomain);
